import z from 'zod';
import { PERMISSIONS, FLOW_PERMISSIONS } from '@shared/constants/permissionService.constant';

const permissionsSchema = z.array(z.enum(PERMISSIONS));
const flowPermissionsSchema = z.array(z.enum(FLOW_PERMISSIONS));

export { flowPermissionsSchema, permissionsSchema };
